import { accentColor, BASIC_COLOR_SET } from 'constants/chartConstants';

import Highcharts from 'highcharts';
import React, { useMemo } from 'react';

import VerticalBarChart from 'components/common/verticalBarChart/VerticalBarChart';

interface SalesPersonaEngagement {
  date: string;
  numberOfImpressions: number;
  top25: number;
  average: number;
  bottom10: number;
}

interface SalesPersonaEngagementChartProps {
  data: SalesPersonaEngagement[];
}

const SalesPersonaEngagementChart = ({
  data,
}: SalesPersonaEngagementChartProps): React.ReactElement => {
  // Memoize bar data to prevent unnecessary recalculations
  const barData = useMemo(
    () => [
      {
        name: 'Top 25%',
        data: data.map((d) => d.top25),
        color: BASIC_COLOR_SET[0], // Green color for Top 25%
      },
      {
        name: 'Average',
        data: data.map((d) => d.average),
        color: BASIC_COLOR_SET[1], // Blue color for Average
      },
      {
        name: 'Bottom 10%',
        data: data.map((d) => d.bottom10),
        color: accentColor, // Accent color for Bottom 10%
      },
    ],
    [data]
  );

  const categories = useMemo(
    () => data.map((engagementData, index) => `Week ${index + 1}`),
    [data]
  );

  const tooltipFormatter = (point: Highcharts.Point) => {
    const baseInfo = `<b>${point.category}</b><br/><br/><b>${point.series.name}</b> of accounts spent <b>${point.y}</b> sales engagement minutes per 10 impressions.`;
    if (point.series.name === 'Average') {
      return `<b>${point.category}</b><br/><br/>The <b>${point.series.name?.toLowerCase()}</b> accounts spent <b>${point.y}</b> sales engagement minutes per 10 Impressions.`;
    }
    return baseInfo;
  };

  return (
    <VerticalBarChart
      categories={categories}
      barData={barData}
      title='Number of Engagement Minutes Per 10 Impressions'
      yAxisTitles={{
        barAxisTitle: 'Engagement Minutes',
      }}
      changeColorOnBarClick={true}
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default SalesPersonaEngagementChart;
